export default __webpack_public_path__ + "static/media/MothsToTheFlame.95c1247d.jpg";